import React from 'react';
import T from 'prop-types';
// components
import PageMessage from 'components/PageMessage';

// Shown when a link from a notification or email points to a page that can't be opened,
// so the user sees why instead of being dropped on the home page.
const LinkUnavailable = (props, { router }) => (
  <PageMessage
    titleId="component.linkUnavailable.title"
    descriptionId="component.linkUnavailable.description"
    actionLabelId="component.linkUnavailable.goHome"
    onAction={() => router.replace('/')}
  />
);

LinkUnavailable.contextTypes = {
  router: T.object.isRequired,
};

export default LinkUnavailable;
